import React from 'react'
import Table from '../../../components/DataTable/Table'
import { useLocation } from 'react-router-dom'
import TableServer from '../../../components/DataTable/TableServer'

function OrderTrackingList(props) {
    const { haveAccessTo, service, needLoad, currentPage, Form, setNeedLoad, drawer } = props
    const location = useLocation()
    const path = location.pathname.split('/')
    const dataId = location.pathname.split('/').pop()

    console.log('path', path[2])

    let headCells = [
        { id: 'date', label: 'Date ', type: 'date' },
        { id: 'code', label: 'Référence ' },
        { id: 'customer', label: 'Client' },
        { id: 'project_type', label: 'Type de projet' },
        { id: 'plantation_type', label: 'Type de plantation' },
        { id: 'location', label: 'Localisation demandée' },
        { id: 'tree_ordered', label: 'Nombre arbres commandés' },
        { id: 'surface', label: 'Surface (Ha)' },
        { id: 'state', label: 'Etat' }
    ]

    if (path[2] === 'agroforestry') {
        headCells = [
            ...headCells,
            {
                id: 'actions',
                type: 'actions',
                label: 'Actions',
                disableSorting: true,
                showEdit: false,
                showRemove: false,
                showView: '/app/agroforestry/order/view',
                forcePassId: true
            }
        ]
    } else if (path[2] === 'mangrove') {
        headCells = [
            ...headCells,
            {
                id: 'actions',
                type: 'actions',
                label: 'Actions',
                disableSorting: true,
                showEdit: false,
                showRemove: false,
                showView: '/app/mangrove/order/view',
                forcePassId: true
            }
        ]
    } else {
        headCells = [
            ...headCells,
            {
                id: 'actions',
                type: 'actions',
                label: 'Actions',
                disableSorting: true,
                showEdit: false,
                showRemove: true,
                showView: '/app/commercial/order/view',
                forcePassId: true
            }
        ]
    }

    return (
        <>
            <TableServer
                headCells={headCells}
                service={service}
                haveAccessTo={haveAccessTo}
                needLoad={needLoad}
                setNeedLoad={setNeedLoad}
                currentPage={currentPage}
                title={`Visualisation de la commande`}
                Form={Form}
                drawer={drawer}
                hideFilterButton={true}
                showSiteButton={false}
                showMangroveSiteButton={false}
            />
        </>
    )
}

export default OrderTrackingList
